<template>
  <SelectBox
    @open="getItems"
    @search="getItems"
    @option:selected="$emit('option:selected', $event)"
    :options="filteredItems"
    :validActivated="validActivated"
    :label="label"
    :noLabel="noLabel"
    :value="value"
    option-field="value"
    :disabled="disabled"
    searchable
    :clearable="clearable"
    @input="$emit('input', $event)"
  >
    <template #selected-option="{ item }">
      {{ item.value }}
    </template>
    <template #option="{ item }">
      {{ item.value }}
    </template>
    <template #not-auth v-if="$status.series === 'NOT_AUTHORIZED'">
      <not-auth></not-auth>
    </template>
  </SelectBox>
</template>

<script>
import Requests from "@/services/Requests";
import SelectBox from "../Base/Inputs/SelectBox.vue";
export default {
  components: {
    SelectBox,
  },
  data() {
    return {
      items: [],
      search: "",
    };
  },
  props: {
    value: {
      default: null,
    },
    clearable: {
      default: false,
      type: Boolean,
    },
    noLabel: {
      default: false,
      type: Boolean,
    },
    label: {
      type: String,
      required: true,
    },
    validActivated: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    filteredItems() {
      return this.items.filter((item) =>
        item.value.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  methods: {
    /**
     * Makes a request to get all batteries that match the given search query.
     *
     * @param {string} search - search query to send to the API
     * @param {function} loading - function to call when the request is sending or done. Pass true to indicate sending, false to indicate done.
     */
    async getItems(search, loading) {
      this.search = search;
      console.log(this.search);
      if (this.items.length > 0) return loading(false);
      loading(true);
      const response = await Requests.Tks.GetDeviceNames({
        query: { search: search },
      });
      console.log(response);
      this.$status.series = response.message;
      if (response.message === "OK") {
        this.items = response.data;
      } else {
        this.items = [];
      }
      loading(false);
    },
  },
};
</script>

<style></style>
